import { useEffect, useState } from "react";

const STORAGE_KEY = "bandwith-show-chords";

/**
 * Hook for managing the "Show Chords" preference.
 * Persists to localStorage so the preference is shared across all song pages.
 */
export function useShowChords() {
  const [showChords, setShowChords] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      setShowChords(stored === "true");
    }
    setMounted(true);
  }, []);

  const handleToggle = (checked: boolean) => {
    setShowChords(checked);
    localStorage.setItem(STORAGE_KEY, String(checked));
  };

  return { showChords, mounted, handleToggle };
}
